var chunkToChildrenMap = {
	"8347": [
		1888,
		8217,
		9785,
		4914,
		5208,
		4457,
		2031,
		1380,
		7227,
		9863,
		3005,
		141,
		2975,
		7551,
		2885,
		1957,
		9373,
		5979,
		9448,
		7457,
		580,
		6740,
		3717,
		4367,
		3104,
		6403,
		6239,
		673,
		7589,
		44
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));